<template>
  <section class="suivi-production">
    <header class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ $t('suiviProduction.title') }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section class="level mgt-20px">
      <div class="level-left">
        <div class="column is-narrow">
          <selecteur-action
            @handleAction="handleAction"
            :options="[]"
            :elementsSelectionnes="false"
            :placeholder="$t('general.placeHolder.groupedAction')"
            titleButton="general.button.apply"
          />
        </div>
        <div class="column is-narrow">
          <form @submit.prevent="recherche()">
            <b-input
              v-model="criteresRechercheFromStore.auto"
              :placeholder="$t('general.button.search')"
              type="search"
              icon="magnify">
            </b-input>
          </form>
        </div>
      <div class='column is-narrow'>
        <button class="button" @click='setShowFiltre'>
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">
            {{$t('general.button.filtre')}}
            <label class="has-text-weight-bold"
                    :class="nombreCritere > 0 ? '' : 'is-invisible'">
              ({{ nombreCritere }})
            </label>
          </span>
        </button>
        <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
          <b-icon icon="close-circle" type="is-danger"></b-icon>
        </span>
      </div>
      </div>
    </section>
    <tableau-kanban
      class="columns board-view overflow-auto"
      v-if="columns"
      :columns="columns"
      @move="moveItem">
      <template slot-scope="{ item }">
          <suivi-production-card
            class="pd-10px mg-10px"
            :demande="item"
            @click="() => handleClick(item)"
            />
      </template>
    </tableau-kanban>
    <div class="componentBrief" v-show="showFiltre">
      <filtre-liste-suivi-production  ref="filtreListeSuiviProduction"
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"/>
    </div>
    <b-modal
      v-model="openDetailPopup"
      :width="800"
      @close="closeDetail">
      <popup-suivi-production-detail-card
        ref="popUpDetailSuiviProd"
        :demandeCard="selectedCard"
        @close="openDetailPopup = false"/>
    </b-modal>
    <b-modal v-model="popUpErreur"
             has-modal-card
             class="modal">
      <pop-up-erreur
        :messHeader="$t('suiviProduction.error.impossible')"
        :messages="messageErreur"
      />
    </b-modal>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Breadcrumb from '@/components/general/breadcrumb';
import SelecteurAction from '@/components/general/selecteurAction';
import SuiviProductionCard from '@/components/logistique/suiviProduction/suiviProductionCard';
import messageErreur from '@/services/general/messageErreur';
import popupSuiviProductionDetailCard from '@/components/logistique/suiviProduction/popupSuiviProductionDetailCard';
import { generateDataSuiviProduction, dispatchDataInColumnsSuiviProduction } from '@/services/logistique/suiviProduction/generateDataSuiviProduction';
import TableauKanban from '@/components/general/tableauKanban';
import actionSuiviProduction from '@/services/logistique/suiviProduction/actionSuiviProduction';
import popUpErreur from '@/components/general/popUpErreur';
import {
  DISPOSITIF_A_POSER,
  DISPOSITIF_EN_COURS_FABRICATION,
  DISPOSITIF_EXPEDIE,
  DISPOSTIF_A_FACTURER,
  DISPOSITIF_FABRICATION_TERMINEE,
} from '@/configuration/logistique/suiviProduction/suiviProductionConfig';
import { shiftFirstsDemandesEnAttente, gestionDemandesDePoseDispositif } from '@/services/logistique/suiviProduction/gestionDemandeEnAttente';
import { DISPOSITIF_FABRIQUE } from '@/configuration/logistique/typeOt/typeOtConfig';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import filtreListeSuiviProduction from '@/components/logistique/suiviProduction/filtreListeSuiviProduction';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/logistique/suiviProduction-mutation-type';
import VALIDATIONS from '@/services/logistique/suiviProduction/validationColumnSuiviProduction';
import { transfertInformationBetweenDemandes } from '@/api/logistique/demandeLogistique';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const SuiviProduction = createNamespacedHelpers('suiviProduction');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'suiviProduction',
  components: {
    appBreadcrumb: Breadcrumb,
    SelecteurAction,
    SuiviProductionCard,
    popupSuiviProductionDetailCard,
    TableauKanban,
    popUpErreur,
    filtreListeSuiviProduction,
  },
  data() {
    return {
      openDetailPopup: false,
      selectedCard: null,
      columns: null,
      popUpErreur: false,
      messageErreur: [],
      showFiltre: false,
    };
  },
  computed: {
    ...SuiviProduction.mapGetters({
      criteresRechercheFromStore: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    tags() {
      return this.parametre(PARAMETRES_KEYS.tag);
    },
    breadcrumb() {
      return [
        {
          title: this.$t('general.breadcrumb.racine'),
          route: this.$PAGE_DEFAULT,
          isActive: false,
        },
        {
          title: this.$t('suiviProduction.breadcrumb.suiviProduction'),
          route: '',
          isActive: true,
        },
      ];
    },
    nombreCritere() {
      const banCritere = ['auto'];
      return calculNombreCritere(this.criteresRechercheFromStore, banCritere);
    },
  },
  methods: {
    ...SuiviProduction.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    handleAction() {
    },
    handleClick(card) {
      this.selectedCard = card;
      this.openDetailPopup = true;
    },
    async closeDetail() {
      await this.$refs.popUpDetailSuiviProd.handleSave();
    },
    async gestionDesCopies(item) {
      if (!VALIDATIONS[DISPOSITIF_FABRICATION_TERMINEE](item)) return;
      const demandes = [
        ...this.columns[DISPOSITIF_A_POSER].data,
        ...this.columns[DISPOSITIF_EXPEDIE].data,
        ...this.columns[DISPOSTIF_A_FACTURER].data,
      ];
      const filteredDemandes = demandes.filter(d => d.ligneCommandeId === item.ligneCommandeId
        && d.ordre > item.ordre);
      const promises = filteredDemandes.map(fd => {
        return transfertInformationBetweenDemandes({
          origineId: item.id,
          destinationId: fd.id,
        });
      });
      const results = (await Promise.all(promises)).map(r => r.data.result);
      results.forEach(result => {
        const demande = demandes.find(d => d.id === result.id);
        demande.tags = result.tags.map(t => {
          return {
            ...t,
            tag: this.tags.find(tag => tag.id === t.tagId),
          };
        });
        demande.description = result.description;
      });
    },
    async gestionDemandeEnAttente(item) {
      if (!item) return;
      if (!VALIDATIONS[DISPOSITIF_EN_COURS_FABRICATION](item)) return;

      const ligneCommandeId = item?.ligneCommandeId || null;
      if (!ligneCommandeId) return;

      const allDemandestoAdd = shiftFirstsDemandesEnAttente(ligneCommandeId);
      // tri entre les demandes de pose et les autres
      if (!allDemandestoAdd.length) return;
      let demandesToAdd = [];
      const demandesDispositifAPoser = [];
      allDemandestoAdd.forEach(d => {
        if (d.typeOt?.actionInterventionOt === DISPOSITIF_FABRIQUE) {
          demandesDispositifAPoser.push(d);
        } else {
          demandesToAdd.push(d);
        }
      });
      demandesToAdd = demandesToAdd.concat(
        (await gestionDemandesDePoseDispositif(demandesDispositifAPoser)),
      );
      this.columns = dispatchDataInColumnsSuiviProduction(this.columns, demandesToAdd, true);
    },
    async moveItem(movement) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const modifiedItem = await actionSuiviProduction(movement);
        movement.approuved(modifiedItem);
        await this.gestionDemandeEnAttente(modifiedItem);
        await this.gestionDesCopies(modifiedItem);
      } catch (error) {
        if (Array.isArray(error)) {
          error.forEach(error => { error.libelle = error.libelle ?? this.$t(error.message); });
          this.messageErreur = error;
          this.popUpErreur = true;
        } else {
          messageErreur(this.$i18n);
        }
      } finally {
        loadingComponent.close();
      }
    },
    async recherche() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.columns = await generateDataSuiviProduction();
      } catch (error) {
        messageErreur(this.$i18n);
        throw error;
      } finally {
        loadingComponent.close();
      }
    },
    async makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      await this.recherche();
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeSuiviProduction.initializeFiltre();
    },
    async reinitialiser() {
      await this.$refs.filtreListeSuiviProduction.initializeFiltre();
      await this.$refs.filtreListeSuiviProduction.viderCritere();
      this.$refs.filtreListeSuiviProduction.appliquerCritere();
      this.showFiltre = false;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const critere = cloneDeep(this.criteresRechercheFromStore);
      await updateCritereWithParametreInterne(critere);
      this.setCritereRecherche(critere);
      await this.loadParametres([PARAMETRES_KEYS.tag]);
      await this.recherche();
      this.setInformationPage(this.$t('pageLogistique.suiviProduction.liste'));
    } catch (error) {
      messageErreur(this.$i18n);
      throw error;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
